import React, { useState } from "react";
import { copyActivationText } from "./activationClipboard";

const BLOCKS = [
  {
    section: "QR Card Text",
    items: [
      { lbl: "QR Card — Standard", text: "Find runs this week\nruncards.app/nyc" },
      { lbl: "QR Card — Traveler", text: "Running in NYC this week?\nruncards.app/nyc/this-week" },
      { lbl: "Strava Bio Line", text: "Find our runs + others in NYC:\nruncards.app/nyc" },
      {
        lbl: "Pre-Run Mention (say this)",
        text: "If you're looking for other runs this week, check RunCards.",
      },
    ],
  },
  {
    section: "Reddit / Forum Posts",
    fullWidth: true,
    items: [
      {
        lbl: "r/RunNYC — Genuine Resource Drop",
        text: "Running in NYC this week? Clean list of group runs by day: runcards.app/nyc — no account, no noise, just times and locations.",
      },
    ],
  },
  {
    section: "Chat Interception Script",
    fullWidth: true,
    items: [
      {
        lbl: 'When someone asks "what\'s tomorrow?" — do this',
        text: `[Don't type anything. Open RunCards. Screenshot the Tomorrow or Week view. Send that.]

If they ask what it is: "just a clean list of runs in the city."`,
      },
    ],
  },
];

export default function ActivationCopyPasteTab() {
  const [copiedKey, setCopiedKey] = useState(null);

  const copy = (text, key) => {
    copyActivationText(text, () => {
      setCopiedKey(key);
      setTimeout(() => setCopiedKey(null), 2000);
    });
  };

  return (
    <>
      <div className="ac-focus-box" style={{ marginBottom: 24 }}>
        <div className="ac-fb-eyebrow">Copy-Paste Kit</div>
        <div className="ac-fb-text ac-serif">
          Zero typing. <em>Every action has a pre-written version. Copy → paste → done.</em>
        </div>
      </div>
      {BLOCKS.map((block) => (
        <div key={block.section}>
          <div className="ac-section-label">{block.section}</div>
          <div
            className="ac-qr-cards"
            style={block.fullWidth ? { gridTemplateColumns: "1fr" } : undefined}
          >
            {block.items.map((it, i) => {
              const key = `${block.section}-${i}`;
              return (
                <div key={key} className="ac-qr-card" style={block.fullWidth ? { gridColumn: "1 / -1" } : undefined}>
                  <div className="ac-qrc-lbl">{it.lbl}</div>
                  <div className="ac-qrc-text">{it.text}</div>
                  <div className="ac-qrc-footer">
                    <button
                      type="button"
                      className={`ac-copy-btn ${copiedKey === key ? "copied" : ""}`}
                      onClick={() => copy(it.text, key)}
                    >
                      {copiedKey === key ? "Copied ✓" : "Copy"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </>
  );
}
